/**
 * Slice global merge-order per-drop rows to match a subset of drop ids (e.g. one country chunk).
 */

export function slicePerDropRowsForItemIds(
  orderedIds: string[],
  rows: string[][] | undefined,
  itemIds: string[],
): string[][] | undefined {
  if (rows == null || rows.length === 0) return undefined;
  const indexOf = new Map(orderedIds.map((id, i) => [id, i]));
  const out: string[][] = [];
  for (const id of itemIds) {
    const j = indexOf.get(id);
    if (j === undefined || j >= rows.length) return undefined;
    out.push(rows[j]!);
  }
  return out;
}
